export default {
  title: 'Swiss Engineers United', sections: {
    index_hero_section: {
      fields: {
        field_one: {
          value: {
            text: 'Leading Swiss engineering group for future development and succession solutions in construction, geomatics and planning.',
            subtext: 'By acquiring your successful engineering firm and jointly developing it further inside SEU, we will position your company as a beacon in the engineering industry.',
            buttonLabel: 'Welcome to the team',
            buttonLink: '/en/about',
            desktop_image: '/seu/hero_autumn_desktop.jpg',
            desktop_video: '/seu/hero_autumn_desktop.mp4',
            mobile_image: '/seu/hero_autumn_mobile.jpg',
            mobile_video: '/seu/hero_autumn_mobile.mp4',
          }
        },
      }
    },
    index_about_section: {
      fields: {
        field_one: {
          value: {
            text1: 'Leading Swiss engineering group for future development and succession solutions in construction, geomatics and planning.',
            text2: 'By acquiring your successful engineering firm and jointly developing it further inside SEU, we will position your company as a beacon in the engineering industry.',

          }
        }
      }
    }, index_features_2_section: {
      fields: {
        field_one: {
          value: {
            boxes: [{
              image: '/seu/latest-icons/engineering.svg',
              title: 'Engineering',
              subTitle: 'We’re leading experts. <br> For geomatics, construction<br> and planning.',
              buttonLabel: 'Engineering',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/en/engineering'
            }, {
              image: '/seu/latest-icons/caracters.svg',
              title: 'Professionals',
              subTitle: 'We create comprehensive <br>solutions. Individually<br> and industry-wide.',
              buttonLabel: 'Strategy',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/en/strategy'
            }, {
              image: '/seu/latest-icons/handshake.svg',
              title: 'Succession Solutions',
              subTitle: 'We’ll make sure your company continues. Successfully and for the long term.',
              buttonLabel: 'Services',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/en/services'
            },]
          }
        }
      }
    }, index_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Seu'
          }
        }
      }
    }, index_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_32.jpg'
          }
        }
      }
    }, index_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">By engineers, </div>  for engineers'
          }
        }, field_two: {
          value: {
            text: 'We lead thriving<br> and innovative<br> engineering firms <br>into the future'
          }
        }, field_three: {
          value: {
            text: 'Are you hoping for a successful and secure succession of ownership? We offer a professional solution – forward looking, as equal partners and with an entrepreneurial spirit. And if stepping back from working life isn’t yet an option, we’re happy to keep you and your expertise on board.',
          }
        }, field_four: {
          value: {
            text: 'Join SEU as a co-entrepreneur – by integrating your company into SEU as a partner organization. Together we’ll steer your company into the future and guide your brand to success.',
            text2: 'From the start, you’ll benefit from synergy effects at all levels. And precisely where it’s needed every time: in personnel recruiting, in administration or when projects hit a bottleneck.',
            buttonLabel: 'Energy from synergy',
            buttonLink: '/en/strategy'
          }
        },
      }
    }, index_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [{
              title: 'Your advantages as <br/> a co-entrepreneur  with SEU',
              image: '/seu/latest-icons/thumbs-up.svg',
              values: [{
                name: 'Your expertise will become part of a robust network with nation-wide appeal.'
              }, {
                name: 'You will help shape the future of the SEU Group and share in its success.'
              }, {
                name: 'You can count on a successful solution to the succession challenge.'
              },]
            }, {
              title: 'Your advantages as <br/> an SEU partner company',
              image: '/seu/latest-icons/circles.svg',
              values: [{
                name: 'Your brand will live on.'
              }, {
                name: 'Your company will retain operational freedom and independence.'
              }, {
                name: 'Your company will benefit from synergy effects and remain competitive for the long term.'
              }]
            },]
          }
        }
      }
    }, index_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Seu'
          }
        }
      }
    }, index_text2_section: {
      fields: {
        field_one: {
          value: {
            text: 'We bring together expertise, dynamic entrepreneurship and the spirit of innovation'
          }
        }, field_two: {
          value: {
            text: 'Swiss Engineers United is the platform for the engineers of tomorrow. We are a group of successful Swiss engineering companies in the fields of  <a href="/en/engineering" class="text-highlight">construction, geomatics and planning</a>.'
          }
        }, field_three: {
          value: {
            text: 'For us, values and vision count more than the size of a company. We inspire innovative ideas, bring peak performance engineering to market and are pioneers when it comes to technology, methodology, digitalization and process optimization.',
            text2: 'No matter whether you run an established SME, enjoy a reputation as a high-profile specialist in your niche, are a seasoned expert or hoping to expand your start-up: We care about your future. With us, your drive and capabilities are in the best hands. We’ll help your ideas find the right launch pad.',
          }
        },
      }
    }, index_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'We look forward to hearing from you',
            text2: 'Let’s engineer the future together!',
            buttonLabel: 'Contact us',
            buttonLink: 'mailto:verwaltungsrat@seu.ch',
            image: '/seu/latest-assets/seu_22.jpg'
          }
        },
      }
    },
  }
}
